import React from 'react';
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import './styles.scss'

const MobileSolution = (props) => {
  return (
    <StaticQuery
      query={graphql`
        query {
          allDataYaml {
            edges {
              node {
                mobilelp {
                  solutions {
                    title
                    automation {
                      problem
                      solution {
                        detail
                        title
                      }
                    }
                    nocode {
                      problem
                      solution {
                        detail
                        title
                      }
                    }
                    recovery {
                      problem
                      solution {
                        detail
                        title
                      }
                    }
                  }
                }
                language
              }
            }
          }
          problemIconFile: allFile(filter: {relativePath: {glob: "mobilelp/solutions/problem/*"}}, sort: {fields: name}) {
            nodes {
              name
              childImageSharp {
                fluid(maxWidth: 56) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
          solutionIconFile: allFile(filter: {relativePath: {glob: "mobilelp/solutions/solution/*"}}, sort: {fields: name}) {
            nodes {
              name
              childImageSharp {
                fluid(maxWidth: 56) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
          thinkingFaceIcon: file(relativePath: {eq: "mobilelp/solutions/thinking-face-emoji.png"}) {
            name
            childImageSharp {
              fluid(maxWidth: 348) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      `}
      render={({ allDataYaml: { edges}, problemIconFile, solutionIconFile, thinkingFaceIcon }) => {
        const { node: { mobilelp: { solutions } } } = edges.find(({node}) => node.language === props.language)
        const { automation, nocode, recovery } = solutions

        const automationProblemIcon = problemIconFile.nodes.find(({name}) => name === "automation-problem-icon")
        const nocodeProblemIcon = problemIconFile.nodes.find(({name}) => name === "nocode-problem-icon")
        const recoveryProblemIcon = problemIconFile.nodes.find(({name}) => name === "recovery-problem-icon")

        const automationIcon = solutionIconFile.nodes.find(({name}) => name === "automation-icon")
        const nocodeIcon = solutionIconFile.nodes.find(({name}) => name === "nocode-icon")
        const recoveryIcon = solutionIconFile.nodes.find(({name}) => name === "recovery-icon")

        return <div className="container mobile-solutions">
          <div className="row">
            <div className="col-12"><h1 className="mobile-solution-heading px-md-5 text-center px-3">{ solutions.title }</h1></div>
          </div>
          <div className="row mt-3 mt-lg-5 overflow-hidden">
            <div className="col-12 col-lg-4">
              <div className="d-flex justify-content-center">
                <div className="thinking-face-emoji d-block d-lg-none mb-3">
                  <Img
                    alt={thinkingFaceIcon.name}
                    fluid={thinkingFaceIcon.childImageSharp.fluid}
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              </div>
              <div className="problem bubble-right bubble-lg-right d-flex justify-content-center align-items-center mt-4 mt-lg-5">
                <div className="problem-icon">
                  <Img
                    alt={automation.problem}
                    fluid={automationProblemIcon.childImageSharp.fluid}
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="problem-title ml-3">{automation.problem}</div>
              </div>
              <div className="solution solution-automation">
                <div className="solution-arrow-up mx-auto d-none d-lg-block"></div>
                <div className="solution-outline mt-4 mt-lg-0">
                  <div className="d-flex justify-content-center align-items-center">
                    <div className="solution-icon">
                      <Img
                        alt={automation.solution.title}
                        fluid={automationIcon.childImageSharp.fluid}
                        loading="lazy"
                        decoding="async"
                      />
                    </div>
                    <h5 className="solution-title ml-3 mb-0">{automation.solution.title}</h5>
                  </div>
                  <div className="solution-outline-description font-weight-normal mt-5">{automation.solution.detail}</div>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="d-flex justify-content-center">
                <div className="thinking-face-emoji d-none d-lg-block mb-5">
                  <Img
                    alt={thinkingFaceIcon.name}
                    fluid={thinkingFaceIcon.childImageSharp.fluid}
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              </div>
              <div className="problem bubble-right bubble-lg-top d-flex justify-content-center align-items-center mt-4 mt-lg-3">
                <div className="problem-icon">
                  <Img
                    alt={nocode.problem}
                    fluid={nocodeProblemIcon.childImageSharp.fluid}
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="problem-title ml-3">{nocode.problem}</div>
              </div>
              <div className="solution solution-nocode">
                <div className="solution-arrow-up mx-auto d-none d-lg-block"></div>
                <div className="solution-outline mt-4 mt-lg-0">
                  <div className="d-flex justify-content-center align-items-center">
                    <div className="solution-icon">
                      <Img
                        alt={nocode.solution.title}
                        fluid={nocodeIcon.childImageSharp.fluid}
                        loading="lazy"
                        decoding="async"
                      />
                    </div>
                    <h5 className="solution-title ml-3 mb-0">{nocode.solution.title}</h5>
                  </div>
                  <div className="solution-outline-description font-weight-normal mt-5">{nocode.solution.detail}</div>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="problem bubble-right bubble-lg-left d-flex justify-content-center align-items-center mt-4 mt-lg-5">
                <div className="problem-icon">
                  <Img
                    alt={recovery.problem}
                    fluid={recoveryProblemIcon.childImageSharp.fluid}
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="problem-title ml-3">{recovery.problem}</div>
              </div>
              <div className="solution solution-recovery">
                <div className="solution-arrow-up mx-auto d-none d-lg-block"></div>
                <div className="solution-outline mt-4 mt-lg-0">
                  <div className="d-flex justify-content-center align-items-center">
                    <div className="solution-icon">
                      <Img
                        alt={recovery.solution.title}
                        fluid={recoveryIcon.childImageSharp.fluid}
                        loading="lazy"
                        decoding="async"
                      />
                    </div>
                    <h5 className="solution-title ml-3 mb-0">{recovery.solution.title}</h5>
                  </div>
                  <div className="solution-outline-description font-weight-normal mt-5">{recovery.solution.detail}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }}
    />
  )
}

export default MobileSolution;
